import { render, staticRenderFns } from "./activity-collect-cards.vue?vue&type=template&id=43dff31c&scoped=true&"
import script from "./activity-collect-cards.vue?vue&type=script&lang=js&"
export * from "./activity-collect-cards.vue?vue&type=script&lang=js&"
import style0 from "./activity-collect-cards.vue?vue&type=style&index=0&id=43dff31c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dff31c",
  null
  
)

export default component.exports